import * as React from 'react';
import { api } from 'services/api';
import type { CreatePrioritizedProductsPayload } from 'contracts/prioritized-products';

export const useCreatePrioritizedProducts = () => {
  const createPrioritizedProducts = React.useCallback(async (payload: CreatePrioritizedProductsPayload) => {
    await api.post('/inventory/prioritized-products/create-many', payload);
  }, []);

  return {
    createPrioritizedProducts,
  };
};